/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StoreLeftMenu from '../../menu/StoreLeftMenu';
import Footer from '../../components/Footer';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

//import $ from 'jquery';
//import '../../slick.js'
import Slider from 'react-slick';

import CollaboComment from './CollaboComment';
import CollaboGoodsEtcList from './CollaboGoodsEtcList';
import CafeMenuSlide from './CafeMenuSlide';
import parse from 'html-react-parser';
import '../../css/eventTab.css';
import moment from 'moment';
import queryString from 'query-string';
import { isMobile } from 'react-device-detect';
// import $ from "jquery";

class StoreCollraboCafe extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    colSerial: 0,
    tabIndex: 0,
    toggle: false,
    likes: 0,
    isLike: 0,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;

    window.scrollTo(0, 0);

    const { location } = this.props;
    const query = queryString.parse(location.search);
    let colSerial = query.i;
    this._getData(colSerial);

    //setTimeout(()=>{
    //this._onGoto(0)
    //}, 2000)
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  _getData = async (colSerial) => {
    // const { pageSize } = this.state;
    //const { match, location } = this.props;
    //const query = queryString.parse(location.search)
    //let colSerial = query.i;
    let i;

    const result = await this._getApi();
    const intReturn = result.data[0].intReturn;
    //const con = result.data[0].con
    //const pageCount = result.data[0].pageCount;
    const collaboList = result.data[0].listData;
    //console.log(collaboList)
    if (intReturn === 0) {
      if (colSerial === '' || colSerial === undefined || colSerial === null) {
        i = 0;
      } else {
        //i = colSerial
        i = collaboList.findIndex((item, index) => {
          //console.log(item.colSerial, colSerial)
          return parseInt(item.colSerial) === parseInt(colSerial);
        });
      }

      //console.log('=======================>')
      ///console.log(i)
      if (this._isLoad) {
        this.setState({
          collaboList: collaboList,
          colSerial: collaboList[i].colSerial,
        });
        //console.log(collaboList[i].colSerial)

        setTimeout(() => {
          this._onGoto(i);
          this._getTop(collaboList[i].colSerial);
        }, 600);
      }
    }
  };

  _getApi = () => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/collaboAllList', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _getTop = async (colSerial) => {
    const result = await this._getTopApi(colSerial);
    const intReturn = result.data[0].intReturn;
    const topInfo = result.data[0].listData;
    //console.log(topInfo)
    //console.log(intReturn)
    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          topInfo,
          //contentIdx: topInfo[0].contentIdx,
          colSerial,
          title: topInfo[0].colTitle,
          likes: topInfo[0].chuchon,
          isLike: topInfo[0].likes,
        });
        this._getGoods(colSerial);
      }
    }
  };
  _getTopApi = (colSerial) => {
    const { apiUrl, loginId } = this.props;
    return axios
      .post(apiUrl + '/collaboTopNew', {
        params: {
          colSerial: colSerial,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  //관련 상품.
  _getGoods = async (serial) => {
    const result = await this._getGoodsApi(serial);
    const intReturn = result.data[0].intReturn;
    const goodList = result.data[0].listData;
    //console.log(intReturn)
    //console.log(goodList)
    if (this._isLoad) {
      if (intReturn === 0) {
        this.setState({
          goodList,
        });
      } else {
        this.setState({
          goodList: [],
        });
      }
    }
  };
  _getGoodsApi = (serial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/storeOriginalGoodsListNew', {
        params: {
          serial: serial,
          goodsType: 'C',
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  /*
    _getGoods = async (colSerial) => {
        const result = await this._getGoodsApi(colSerial)
        const intReturn = result.data[0].intReturn;
        const goodList = result.data[0].listData;
        //console.log(intReturn)
        //console.log(goodList)
        //console.log(goodList)
        if(intReturn === 0) {
            this.setState({
                goodList,
                colSerial
            })
        }
    }
    _getGoodsApi = (colSerial) => {
        const { apiUrl } = this.props;
        return axios.post(apiUrl + '/storeCollaboGoodsList', {
            params: {
                colSerial: colSerial
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  _renderItem = () => {
    const { collaboList } = this.state;

    const list = collaboList.map((item, index) => {
      return (
        <div
          className="store_orgin_item"
          key={index}
          onClick={() => this._onGoto(index)}
        >
          {/* 콜라보 카페 */}
          <div className="orgin_goods">
            {item.endDate > moment(new Date()).format('YYYY-MM-DD') ? (
              <div className="ico_new">new</div>
            ) : null}
            <div className="thumb circle">
              <img src={item.listImg} alt="" />
            </div>
            {/* <div className="subject">
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => this._onGoto(index)}
              >
                {item.colTitle}
              </a>
            </div> */}
          </div>
        </div>
      );
    });

    return list;
  };
  _online = (goodSerial, SaleActive) => {
    if (SaleActive) {
      window.open('https://shop.aniplustv.com/Item/' + goodSerial, '', '');
    } else {
      toast.warn('오프라인에서만 구매가 가능한 굿즈입니다.');
    }
  };
  _renderGoodItem = () => {
    const { goodList } = this.state;
    const con = goodList.length;
    const { imgUrl } = this.props;
    const list = goodList.map((item, index) => {
      return (
        <div
          key={index}
          className="img_orgin_item"
          style={{
            width: item.imgType === 'W' || item.imgType === 'X' ? '100%' : null,
          }}
          index={index}
          con={con}
        >
          <div
            className={
              item.imgType === 'W' || item.imgType === 'X'
                ? 'inven_status_wide'
                : 'inven_status'
            }
            style={{ bottom: item.imgType === 'X' ? 7 : null }}
          >
            <dl>
              {/*<dt>서울</dt>*/}
              <dd>
                {item.h_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/h_no.png'} />
                ) : item.h_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/h_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/h_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>대전</dt>*/}
              <dd>
                {item.d_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/d_no.png'} />
                ) : item.d_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/d_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/d_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>광주</dt>*/}
              <dd>
                {item.g_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/g_no.png'} />
                ) : item.g_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/g_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/g_soon.png'} />
                )}
              </dd>
            </dl>
            <dl>
              {/*<dt>부산</dt>*/}
              <dd>
                {item.b_stock <= 0 ? (
                  <img src={imgUrl + '/img/store/b_no.png'} />
                ) : item.b_stock >= 10 ? (
                  <img src={imgUrl + '/img/store/b_full.png'} />
                ) : (
                  <img src={imgUrl + '/img/store/b_soon.png'} />
                )}
              </dd>
            </dl>
          </div>
          <img src={item.imageS} />{' '}
          {/* 실제 서비스시 originalImg 등록 후 변경할 것 */}
        </div>
      );
    });
    return list;
  };
  _afterChange = (index, idx) => {};

  _beforChange = (current, next) => {
    const { collaboList } = this.state;
    if (collaboList) {
      const colSerial = collaboList[next].colSerial;

      this._getTop(colSerial);
      this.setState({
        slideIndex: next,
      });
    } else {
      this.setState({
        slideIndex: next,
      });
    }
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    const { collaboList } = this.state;
    ////console.log(i)
    //console.log(i)
    const colSerial = collaboList[i].colSerial;
    //console.log(colSerial)
    if (this._isLoad) {
      this.slider.slickGoTo(i);
      this._getTop(colSerial);
    }
  };
  _back = () => {
    const { history } = this.props;

    history.goBack();
  };
  _toggleTab = (tabIndex) => {
    this.setState({
      tabIndex,
    });
  };
  _toggle = () => {
    const { toggle } = this.state;

    this.setState({
      toggle: !toggle,
    });
  };
  _onLike = async () => {
    const { loginId } = this.props;
    const { likes } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      const result = await this._onLikeApi();
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //좋아요 성공
        this.setState({
          isLike: 100,
          likes: likes + 1,
        });
      } else {
        this.setState({
          isLike: 0,
          likes: likes - 1,
        });
        //좋아요 취소
      }
    }
  };
  _onLikeApi = () => {
    const { apiUrl, loginId } = this.props;
    const { colSerial } = this.state;
    return axios
      .post(apiUrl + '/collaboLike', {
        params: {
          idx: colSerial,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _onNaver = () => {
    const { colSerial, title } = this.state;
    const url = 'http://www.aniplustv.com/storeCollaboCafe/' + colSerial;
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
  };
  _onTwitter = () => {
    const { colSerial, title } = this.state;
    const url = 'http://www.aniplustv.com/storeCollaboCafe/' + colSerial;
    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
  };
  _onFacebook = () => {
    const { colSerial, title } = this.state;
    const url = 'http://www.aniplustv.com/storeCollaboCafe/' + colSerial;
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600',
    );
  };
  _onInstar = () => {
    const { colSerial } = this.state;
    const url = 'http://www.aniplustv.com/storeCollaboCafe/' + colSerial;
    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600',
    );
  };
  _onKakao = () => {
    const { colSerial } = this.state;
    const url = 'http://www.aniplustv.com/storeCollaboCafe/' + colSerial;
    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600',
    );
  };
  render() {
    const {
      collaboList,
      colSerial,
      topInfo,
      goodList,
      tabIndex,
      toggle,
      isLike,
      likes,
    } = this.state;
    const { imgUrl } = this.props;
    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 12,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      //speed: 3000,
      className: 'store_orgin_list',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      centerMode: false,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };
    return (
      <Fragment>
        <div className="content">
          <StoreLeftMenu />

          {/* 오른쪽 콘텐츠 */}
          <div className="vod_list_right store_right">
            <div className="vod_list_group">
              <div className="store_wrap">
                {/* 스토어 스토리 */}
                <div className="store_blog orgin">
                  {/* 스토리 상단 */}
                  <div className="blog_top">
                    <h2 className="tit">
                      <button
                        type="button"
                        className="btn_prev"
                        onClick={this._back}
                      >
                        <img
                          src={imgUrl + '/img/store/arrw_pre.svg'}
                          alt="이전"
                        />
                      </button>
                      콜라보 카페
                    </h2>
                    {topInfo ? (
                      <ul className="post_info">
                        <li className="data">
                          {/* 서울 seoul, 대전 daejeon, 광주 gwangju, 부산 busan / */}
                          {/*<span className="writer busan"></span>
                                                    <span className="date"></span>*/}
                        </li>
                        <li className="social">
                          <ul className="story_social">
                            <li className="story_ico">
                              <span
                                className={
                                  isLike > 0 ? 'ico_like active' : 'ico_like'
                                }
                                onClick={this._onLike}
                              ></span>
                              <span className="num">{likes}</span>
                            </li>
                            <li className="story_ico">
                              <span className="ico_reply"></span>
                              <span className="num">
                                {topInfo[0].comment_count}
                              </span>
                            </li>
                            <li className="story_ico">
                              <span className="ico_read"></span>
                              <span className="num">{topInfo[0].readNum}</span>
                            </li>
                            <li className="story_ico btn_more">
                              <span className="ico_more"></span>
                              <ul className="more_wrap">
                                <li>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._onFacebook}
                                  >
                                    <img
                                      src={imgUrl + '/img/store/sns_fb.png'}
                                      alt="페이스북"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._onKakao}
                                  >
                                    <img
                                      src={imgUrl + '/img/store/sns_kako.png'}
                                      alt="카카오"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._onInstar}
                                  >
                                    <img
                                      src={imgUrl + '/img/store/sns_google.png'}
                                      alt="구글"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._onTwitter}
                                  >
                                    <img
                                      src={imgUrl + '/img/store/sns_twt.png'}
                                      alt="트위터"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={this._onNaver}
                                  >
                                    <img
                                      src={imgUrl + '/img/store/sns_naver.png'}
                                      alt="네이버"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    ) : null}
                  </div>

                  {/* 스토리 본문 */}
                  <div className="blog_container">
                    {/* 오리지널 굿즈 */}
                    <div className="store_orgin">
                      {/* 오리지널 굿즈 상단 */}
                      {/*
                                            <div className="store_orgin_top">
                                                <h3><span className="tag">콜라보 카페</span> <strong className="num">총 {con}개</strong></h3>
                                                <ul className="store_orgin_rt">
                                                    <li>
                                                        오직 애니플러스에서만 만날 수 있는 애니플러스 콜라보 카페<em>!</em><br/>
                                                        국내 최대 규모, 최고의 퀄리티, 애니플러스만이 가능한 노하우로 고객님이 만족하시는 콜라보 카페를 만듭니다.
                                                    </li>
                                                    <li>
                                                        <img src="/img/store/aniplus_orgin.png" alt="ANIPLUS ORIGINAL GOODS"/>
                                                    </li>
                                                </ul>
                                            </div>
                                            */}
                      {/* 오리지널 굿즈 컨테이너 */}
                      <div
                        className="store_orgin_container"
                        onMouseEnter={this._toggle}
                        onMouseLeave={this._toggle}
                      >
                        {/* 슬라이드 이전/다음 */}
                        {toggle ? (
                          <>
                            <button
                              type="button"
                              className="orgin_arrw prev"
                              onClick={this._onPrev}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_prev.svg'}
                                alt="이전"
                              />
                            </button>
                            <button
                              type="button"
                              className="orgin_arrw next"
                              onClick={this._onNext}
                            >
                              <img
                                src={imgUrl + '/img/store/arrw_slide_next.svg'}
                                alt="다음"
                              />
                            </button>
                          </>
                        ) : null}

                        {/* 오리지널 굿즈 리스트 */}
                        {/*<div className="store_orgin_list">*/}
                        <Slider
                          ref={(ref) => (this.slider = ref)}
                          {...settings}
                        >
                          {collaboList ? this._renderItem() : null}
                        </Slider>
                        {/*</div>*/}
                      </div>
                    </div>
                    {/* 내용 */}
                    {topInfo ? (
                      topInfo.length > 0 ? (
                        <div className="blog_content">
                          <div className="eventTab">
                            <a
                              onClick={() => this._toggleTab(0)}
                              className={tabIndex === 0 ? 'active' : null}
                              style={{ cursor: 'pointer' }}
                            >
                              {topInfo[0].location}
                              <span>- {topInfo[0].start_h} OPEN -</span>
                            </a>

                            {topInfo[0].sImg1 === '' ||
                            topInfo[0].sImg1 === null ||
                            topInfo[0].sImg1 === undefined ? null : (
                              <a
                                onClick={() => this._toggleTab(1)}
                                className={tabIndex === 1 ? 'active' : null}
                                style={{ cursor: 'pointer' }}
                              >
                                {topInfo[0].location_d}
                                <span>- {topInfo[0].start_d} OPEN -</span>
                              </a>
                            )}
                            {topInfo[0].sImg2 === '' ||
                            topInfo[0].sImg2 === null ||
                            topInfo[0].sImg2 === undefined ? null : (
                              <a
                                onClick={() => this._toggleTab(2)}
                                className={tabIndex === 2 ? 'active' : null}
                                style={{ cursor: 'pointer' }}
                              >
                                {topInfo[0].location_g}
                                <span>- {topInfo[0].start_g} OPEN -</span>
                              </a>
                            )}
                            {topInfo[0].sImg3 === '' ||
                            topInfo[0].sImg3 === null ||
                            topInfo[0].sImg3 === undefined ? null : (
                              <a
                                onClick={() => this._toggleTab(3)}
                                className={tabIndex === 3 ? 'active' : null}
                                style={{ cursor: 'pointer' }}
                              >
                                {topInfo[0].location_b}
                                <span>- {topInfo[0].start_b} OPEN -</span>
                              </a>
                            )}
                          </div>
                          <div className="img_orgin">
                            <div className="img_orgin_visual">
                              <img
                                src={
                                  topInfo.length > 0 ? topInfo[0].topImg : null
                                }
                              />
                              {/*실제 서비스시 image2에 등록후에 변경 할 것 */}
                            </div>

                            <div className="collabocafe_baner_text">
                              {isMobile || colSerial === 103 ? null : (
                                <div className="collabocafe_baner_text_open">
                                  <span>
                                    {tabIndex === 0
                                      ? topInfo[0].start_h
                                      : tabIndex === 1
                                        ? topInfo[0].start_d
                                        : tabIndex === 2
                                          ? topInfo[0].start_g
                                          : tabIndex === 3
                                            ? topInfo[0].start_b
                                            : null}
                                  </span>
                                  <strong>OPEN</strong>
                                  <em>
                                    {tabIndex === 0
                                      ? topInfo[0].location
                                      : tabIndex === 1
                                        ? topInfo[0].location_d
                                        : tabIndex === 2
                                          ? topInfo[0].location_g
                                          : tabIndex === 3
                                            ? topInfo[0].location_b
                                            : null}
                                  </em>
                                  <div className="copy_text">
                                    {topInfo[0].copy}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="slide_group" id="menu_0">
                              {colSerial === 0 || colSerial >= 44 ? null : (
                                <CafeMenuSlide colSerial={colSerial} />
                              )}
                              <img src={topInfo[0].slideBgImg} />
                            </div>
                            <div className="img_orgin_visual">
                              <img
                                src={
                                  tabIndex === 0
                                    ? topInfo[0].sImg
                                    : tabIndex === 1
                                      ? topInfo[0].sImg1
                                      : tabIndex === 2
                                        ? topInfo[0].sImg2
                                        : tabIndex === 3
                                          ? topInfo[0].sImg3
                                          : null
                                }
                              />
                              {/*주차별 특전*/}
                            </div>
                            <div className="img_orgin_visual">
                              <img
                                src={
                                  tabIndex === 0
                                    ? topInfo[0].sInfoImg
                                    : tabIndex === 1
                                      ? topInfo[0].sInfoImg1
                                      : tabIndex === 2
                                        ? topInfo[0].sInfoImg2
                                        : tabIndex === 3
                                          ? topInfo[0].sInfoImg3
                                          : null
                                }
                              />
                              {/*일일한전 수량 특전*/}
                            </div>
                            <div className="img_orgin_visual">
                              <img
                                src={
                                  tabIndex === 0
                                    ? topInfo[0].eventImg
                                    : tabIndex === 1
                                      ? topInfo[0].eventImg1
                                      : tabIndex === 2
                                        ? topInfo[0].eventImg2
                                        : tabIndex === 3
                                          ? topInfo[0].eventImg3
                                          : null
                                }
                              />
                            </div>
                            <div className="img_orgin_list">
                              {goodList ? (
                                goodList.length > 0 ? (
                                  this._renderGoodItem()
                                ) : (
                                  <div className="img_orgin_visual">
                                    <img
                                      src={
                                        tabIndex === 0
                                          ? topInfo[0].goodsImg
                                          : tabIndex === 1
                                            ? topInfo[0].goodsImg1
                                            : tabIndex === 2
                                              ? topInfo[0].goodsImg2
                                              : tabIndex === 3
                                                ? topInfo[0].goodsImg3
                                                : null
                                      }
                                    />
                                  </div>
                                )
                              ) : (
                                <div className="img_orgin_visual">
                                  <img
                                    src={
                                      tabIndex === 0
                                        ? topInfo[0].goodsImg
                                        : tabIndex === 1
                                          ? topInfo[0].goodsImg1
                                          : tabIndex === 2
                                            ? topInfo[0].goodsImg2
                                            : tabIndex === 3
                                              ? topInfo[0].goodsImg3
                                              : null
                                    }
                                  />
                                </div>
                              )}
                              {/*
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_soon.png" alt="매진임박"/></button><img src="/img/store/origin/web_01.png"/></div>
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_btn.png" alt="온라인구매"/></button><img src="/img/store/origin/web_02.png"/></div>

                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_03.png"/></div>
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_soldout.png" alt="상품품절"/></button><img src="/img/store/origin/web_04.png"/></div>
                                                        
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_05.png"/></div>
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_06.png"/></div>
                                                    
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_07.png"/></div>
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_08.png"/></div>
                                                    
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_09.png"/></div>
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_10.png"/></div>
                                                    
                                                        <div className="img_orgin_item"><button type="button" className="ico_goods"><img src="/img/store/ico_goods_full.png" alt="재고충분"/></button><img src="/img/store/origin/web_11.png"/></div>   
                                                        */}
                            </div>
                            <div className="img_orgin_visual">
                              <div className="collabocafe_caution">
                                <div className="collabocafe_caution_text">
                                  {tabIndex === 0
                                    ? parse(topInfo[0].notice)
                                    : tabIndex === 1
                                      ? parse(topInfo[0].notice1)
                                      : tabIndex === 2
                                        ? parse(topInfo[0].notice2)
                                        : tabIndex === 3
                                          ? parse(topInfo[0].notice3)
                                          : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="blog_content">
                          <div
                            className="img_orgin"
                            style={{
                              textAlign: 'center',
                              padding: 50,
                              fontSize: 20,
                            }}
                          >
                            콜라보카페 정보를 준비중에 있습니다.
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="blog_content">
                        <div
                          className="img_orgin"
                          style={{
                            textAlign: 'center',
                            padding: 50,
                            fontSize: 20,
                          }}
                        >
                          로딩중...
                        </div>
                      </div>
                    )}
                  </div>

                  {/* 댓글 */}
                  {colSerial !== 0 ? <CollaboComment idx={colSerial} /> : null}
                </div>

                {/* 오리지널 굿즈 온라인 판매 */}
                {colSerial !== 0 ? (
                  <CollaboGoodsEtcList idx={colSerial} />
                ) : null}
              </div>
            </div>
            <Footer />
          </div>
          {/* /220109 store */}
          <div className="clear"></div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreCollraboCafe)));
